import { getTimestampedFileNameForWidget } from '@app/widgets/helpers/widgets';
import { EChartsOption } from 'echarts';

const WeatherChartConfig: EChartsOption = {
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'cross',
      crossStyle: {
        color: '#999',
      },
    },
  },
  toolbox: {
    show: true,
    feature: {
      mark: { show: true },
      dataView: { show: true, readOnly: true },
      saveAsImage: {
        show: true,
        name: getTimestampedFileNameForWidget('weather'),
      },
    },
  },
  grid: {
    top: '25%',
    left: '5%',
    right: '5%',
    bottom: '3%',
    containLabel: true,
  },
  color: ['#0B3CA4', '#07add6'],
  legend: {
    data: ['Precipitation', 'Wind Speed'],
  },
  xAxis: [
    {
      type: 'category',
      axisPointer: {
        type: 'shadow',
      },
    },
  ],
  yAxis: [
    {
      type: 'value',
      name: 'Precipitation',
      min: 0,
      interval: 5,
      axisLabel: {
        formatter: '{value} mm',
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: '#0B3CA4',
        },
      },
    },
    {
      type: 'value',
      name: 'Wind Speed',
      min: 0,
      max: 25,
      interval: 5,
      axisLabel: {
        formatter: '{value} m/sec',
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: '#07add6',
        },
      },
    },
  ],
  series: [
    {
      name: 'Precipitation',
      type: 'bar',
    },
    {
      name: 'Wind Speed',
      type: 'line',
      lineStyle: {
        width: 2,
      },
      yAxisIndex: 1,
    },
  ],
};

export default WeatherChartConfig;
